import { ProjectsSetTokensReducer } from './types';

export const projectsSetTokensReducer: ProjectsSetTokensReducer = (
  state,
  action
) => {
  const tokens = action.payload;

  return {
    ...state,
    projects: tokens,
  };
};
